import * as ACTIONS from "../actions";

import Api from "../../services";

import cm from "./CommonFunction";

const BuyRequestModule = {
  state: {
    LOADING: false,
    BUYREQUEST: [],
    ERRORMESSAGE: null,
    TOTALPAGES: 1,
    REQUEST: [],
    //COMMODITIES: [],
    COMMODITYVENDORS: [],
    SUPPLIER: [],
    PURCHASER: [],
    CURRENCY: [],
    //REQUESTTYPE: [],
    DEPARTMENTS: [],
    BUYREQUESTSAVEERROR: null,
    BUYREQUESTSAVELOADING: false,
    BUYREQUESTBANKCOMMODITIES: [],
    CLIENTNAMES: [],
    TRANSACTIONTYPE: [],
    ACCEPTEDLISTLOADING: false,
    ACCEPTEDLISTERRORMESSAGE: null,

    SELLREQUEST: [],
    SELREQUESTLOADING: false,
    SELLREQUESTERROR: null,

    CANCELLOADING: false,
    CANCELERROR: null,
  },
  getters: {
    GETBUYREQUESTS: (state) => state.BUYREQUEST,
    GETBUYREQUESTLOADING: (state) => state.LOADING,
    GETBUYREQUESTERRORMESSAGE: (state) => state.ERRORMESSAGE,
    GETBUYREQUESTTOTATLPAGES: (state) => state.TOTALPAGES,

    GETBUYREQUEST: (state) => state.REQUEST,
    GETBUYREQUESTCOMMODITIES: (state) => state.COMMODITYVENDORS,
    GETREQUESTDEPARTMENTS: (state) => state.DEPARTMENTS,
    GETCURRENCY: (state) => state.CURRENCY,
    //GETREQUESTTYPE: state => state.REQUESTTYPE,
    GETBUYREQUESTSAVEERROR: (state) => state.BUYREQUESTSAVEERROR,
    GETBUYREQUESTSAVELOADING: (state) => state.BUYREQUESTSAVELOADING,
    GETBUYREQUESTBANKCOMMODITIES: (state) => state.BUYREQUESTBANKCOMMODITIES,
    GETCLIENTNAMES: (state) => state.CLIENTNAMES,
    GETTRANSACTIONTYPE: (state) => state.TRANSACTIONTYPE,

    GETACCEPTEDLISTLOADING: (state) => state.ACCEPTEDLISTLOADING,
    GETACCEPTEDLISTERRORMESSAGE: (state) => state.ACCEPTEDLISTERRORMESSAGE,

    GETSELLREQUEST: (state) => state.SELLREQUEST,
    GETSELREQUESTLOADING: (state) => state.SELREQUESTLOADING,
    GETSELLREQUESTERROR: (state) => state.SELLREQUESTERROR,

    GETCANCELERROR: (state) => state.CANCELERROR,
    GETCANCELLOADING: (state) => state.CANCELLOADING,
  },
  actions: {
    [ACTIONS.BUY_REQUEST_GETALL]: (context, query) => {
      context.commit(ACTIONS.BUY_REQUEST_GETALL_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Request/GetAllBuyRequest" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.BUY_REQUEST_GETALL_SUCCESS,
              ACTIONS.BUY_REQUEST_GETALL_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.BUY_REQUEST_GETALL_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.BUY_REQUEST_GET]: (context, query) => {
      context.commit(ACTIONS.BUY_REQUEST_GET_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Request/GetBuyRequest" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.BUY_REQUEST_GET_SUCCESS,
              ACTIONS.BUY_REQUEST_GET_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.BUY_REQUEST_GET_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.BUY_REQUEST_SAVE]: (context, params) => {
      context.commit(ACTIONS.BUY_REQUEST_SAVE_PENDING);
      return new Promise((resolve, reject) => {
        Api.post("Request/SaveBuyRequest", params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            var { data } = res;
            if (data && data.StatusCode == 422) {
              context.commit(
                ACTIONS.DUPLICATE_REFENCE_ERROR,
                data.ResponseData,
              );
            } else {
              commit.success(
                context,
                res,
                ACTIONS.BUY_REQUEST_SAVE_SUCCESS,
                ACTIONS.BUY_REQUEST_SAVE_ERROR,
                true,
              );
            }
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.BUY_REQUEST_SAVE_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.BUY_REQUEST_VIEW]: (context, query) => {
      context.commit(ACTIONS.BUY_REQUEST_VIEW_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Request/ViewByRequest" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.BUY_REQUEST_VIEW_SUCCESS,
              ACTIONS.BUY_REQUEST_VIEW_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.BUY_REQUEST_VIEW_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.SAVE_ACCEPTED_LIST]: (context, params) => {
      context.commit(ACTIONS.SAVE_ACCEPTED_LIST_PENDING);
      return new Promise((resolve, reject) => {
        Api.post("Request/SaveAcceptedBuyRequest", params, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.SAVE_ACCEPTED_LIST_SUCCESS,
              ACTIONS.SAVE_ACCEPTED_LIST_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.SAVE_ACCEPTED_LIST_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.GET_ALL_SELL_REUQEST]: (context, query) => {
      context.commit(ACTIONS.GET_ALL_SELL_REUQEST_PENDING);
      return new Promise((resolve, reject) => {
        Api.get("Request/GetAllSellRequest" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.GET_ALL_SELL_REUQEST_SUCCESS,
              ACTIONS.GET_ALL_SELL_REUQEST_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.GET_ALL_SELL_REUQEST_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.CANCEL_TRANSACTION]: (context, query) => {
      context.commit(ACTIONS.CANCEL_TRANSACTION_PENDING);
      return new Promise((resolve, reject) => {
        Api.post("Request/CancelBuyRequest", query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.CANCEL_TRANSACTION_SUCCESS,
              ACTIONS.CANCEL_TRANSACTION_ERROR,
              true,
            );
            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.CANCEL_TRANSACTION_ERROR);
            return reject(err);
          });
      });
    },

    [ACTIONS.SALE_CONFIRMATION_SAVE]: (context, query) => {
      context.commit(ACTIONS.SALE_CONFIRMATION_SAVE_PENDING);
      return new Promise((resolve, reject) => {
        Api.post("Request/SaveSellConfirmation", query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.SALE_CONFIRMATION_SAVE_SUCCESS,
              ACTIONS.SALE_CONFIRMATION_SAVE_ERROR,
              true,
            );

            return resolve(res);
          })
          .catch((err) => {
            commit.Error(context, err, ACTIONS.SALE_CONFIRMATION_SAVE_ERROR);
            return reject(err);
          });
      });
    },
    [ACTIONS.BUY_REQUEST_COMMODITYPRICES_GET]: (context, query) => {
      context.commit(ACTIONS.BUY_REQUEST_COMMODITYPRICES_GET_PENDING);

      return new Promise((resolve, reject) => {
        Api.get("Request/GetCommodityPricesByDate" + query, {
          headers: {
            token: context.rootState.LoginModule.token,
            cvx: cm.GetRefreshToken(),
          },
        })
          .then((res) => {
            commit.success(
              context,
              res,
              ACTIONS.BUY_REQUEST_COMMODITYPRICES_GET_SUCCESS,
              ACTIONS.BUY_REQUEST_COMMODITYPRICES_GET_ERROR,
              true,
            );

            return resolve(res);
          })
          .catch((err) => {
            commit.Error(
              context,
              err,
              ACTIONS.BUY_REQUEST_COMMODITYPRICES_GET_ERROR,
            );
            return reject(err);
          });
      });
    },
  },
  mutations: {
    [ACTIONS.BUY_REQUEST_GETALL_ERROR]: (state, msg) => {
      state.ERRORMESSAGE = msg;
      state.LOADING = false;
    },
    [ACTIONS.BUY_REQUEST_GETALL_SUCCESS]: (state, data) => {
      state.ERRORMESSAGE = null;
      state.LOADING = false;
      state.BUYREQUEST = data.buyRequests;
      state.TOTALPAGES = data.totalRecords;
    },
    [ACTIONS.BUY_REQUEST_GETALL_PENDING]: (state) => {
      state.ERRORMESSAGE = null;
      state.LOADING = true;
    },

    [ACTIONS.BUY_REQUEST_GET_ERROR]: (state, msg) => {
      state.BUYREQUESTSAVEERROR = msg;
      state.BUYREQUESTSAVELOADING = false;
    },
    [ACTIONS.BUY_REQUEST_GET_SUCCESS]: (state, data) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = false;
      //state.REQUEST = data.buyRequest;
      //state.SUPPLIER = data.supplier;
      //state.PURCHASER = data.purchaser;
      state.DEPARTMENTS = data.Departments;
      //state.REQUESTTYPE = data.RequestType;
      state.CURRENCY = data.Currency;
      //state.COMMODITYVENDORS = data.commodityVendors;
      state.BUYREQUESTBANKCOMMODITIES = data.commodities;
      state.CLIENTNAMES = data.clientNames;
      state.TRANSACTIONTYPE = data.TransactionType;
    },
    [ACTIONS.BUY_REQUEST_GET_PENDING]: (state) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = true;
    },
    [ACTIONS.BUY_REQUEST_SAVE_ERROR]: (state, msg) => {
      state.BUYREQUESTSAVEERROR = msg;
      state.BUYREQUESTSAVELOADING = false;
    },
    [ACTIONS.BUY_REQUEST_SAVE_PENDING]: (state) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = true;
    },
    [ACTIONS.BUY_REQUEST_SAVE_SUCCESS]: (state) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = false;
    },

    [ACTIONS.BUY_REQUEST_VIEW_ERROR]: (state, msg) => {
      state.BUYREQUESTSAVEERROR = msg;
      state.BUYREQUESTSAVELOADING = false;
    },
    [ACTIONS.BUY_REQUEST_VIEW_PENDING]: (state) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = true;
    },
    [ACTIONS.BUY_REQUEST_VIEW_SUCCESS]: (state, data) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = false;
      state.REQUEST = data.requestDetails;
    },
    [ACTIONS.SAVE_ACCEPTED_LIST_PENDING]: (state) => {
      state.ACCEPTEDLISTLOADING = true;
      state.ACCEPTEDLISTERRORMESSAGE = null;
    },
    [ACTIONS.SAVE_ACCEPTED_LIST_ERROR]: (state, msg) => {
      state.ACCEPTEDLISTLOADING = false;
      state.ACCEPTEDLISTERRORMESSAGE = msg;
    },
    [ACTIONS.SAVE_ACCEPTED_LIST_SUCCESS]: (state) => {
      state.ACCEPTEDLISTLOADING = false;
      state.ACCEPTEDLISTERRORMESSAGE = false;
    },
    [ACTIONS.GET_ALL_SELL_REUQEST_ERROR]: (state, msg) => {
      state.SELLREQUESTERROR = msg;
      state.SELREQUESTLOADING = false;
    },
    [ACTIONS.GET_ALL_SELL_REUQEST_SUCCESS]: (state, data) => {
      state.SELLREQUESTERROR = null;
      state.SELLREQUEST = data.sellRequest;
      state.TOTALPAGES = data.totalRecords;
      state.SELREQUESTLOADING = false;
    },
    [ACTIONS.GET_ALL_SELL_REUQEST_PENDING]: (state) => {
      state.SELLREQUESTERROR = null;
      state.SELREQUESTLOADING = true;
    },
    [ACTIONS.CANCEL_TRANSACTION_PENDING]: (state) => {
      state.CANCELERROR = null;
      state.CANCELLOADING = true;
    },
    [ACTIONS.CANCEL_TRANSACTION_SUCCESS]: (state) => {
      state.CANCELERROR = null;
      state.CANCELLOADING = false;
    },
    [ACTIONS.CANCEL_TRANSACTION_ERROR]: (state, msg) => {
      state.CANCELERROR = msg;
      state.CANCELLOADING = false;
    },
    [ACTIONS.SALE_CONFIRMATION_SAVE_PENDING]: (state) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = true;
    },
    [ACTIONS.SALE_CONFIRMATION_SAVE_SUCCESS]: (state) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = false;
    },
    [ACTIONS.SALE_CONFIRMATION_SAVE_ERROR]: (state, msg) => {
      state.BUYREQUESTSAVEERROR = msg;
      state.BUYREQUESTSAVELOADING = false;
    },
    [ACTIONS.DUPLICATE_REFENCE_ERROR]: (state, data) => {
      state.DEPARTMENTS = data.Departments;
      state.BUYREQUESTSAVEERROR =
        "Duplicate Reference Please Try to Save once again";
      state.BUYREQUESTSAVELOADING = false;
    },

    [ACTIONS.BUY_REQUEST_COMMODITYPRICES_GET_PENDING]: (state) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = true;
    },
    [ACTIONS.BUY_REQUEST_COMMODITYPRICES_GET_SUCCESS]: (state, data) => {
      state.BUYREQUESTSAVEERROR = null;
      state.BUYREQUESTSAVELOADING = false;

      state.BUYREQUESTBANKCOMMODITIES = data.Commodity;
    },
    [ACTIONS.BUY_REQUEST_COMMODITYPRICES_GET_ERROR]: (state, msg) => {
      state.BUYREQUESTSAVEERROR = msg;
      state.BUYREQUESTSAVELOADING = false;
    },
  },
};

const commit = {
  success: function(
    context,
    res,
    SuccessAction,
    ErrorAction,
    saveData = false,
  ) {
    var { commit } = context;
    var { data } = res;
    if (data && data.StatusCode == 200) {
      if (saveData) {
        commit(SuccessAction, data.ResponseData);
      } else {
        commit(SuccessAction);
      }
    } else if (
      data &&
      (data.StatusCode == 500 ||
        data.StatusCode == 403 ||
        data.StatusCode == 2 ||
        data.StatusCode == 429 ||
        data.StatusCode == 1 ||
        data.StatusCode == 406 ||
        data.StatusCode == 0)
    ) {
      commit(ErrorAction, data.StatusMessage);
    } else if (data && data.StatusCode == 450) {
      commit(ErrorAction, "Validation Failed");
    } else {
      commit(ErrorAction, "Unknown Error");
    }
  },
  Error: function(context, err, ActionName) {
    var { commit } = context;
    if (err.response) {
      commit(ActionName, "Error " + err.status);
    }
    if (err.request) {
      commit(ActionName, err.message);
    } else {
      // Something happened in setting up the request that triggered an Error

      commit(ActionName, "Error " + err.message);
    }
  },
};
export default BuyRequestModule;
